import { Facebook, Instagram, SocialX, Youtube } from "assets/icons";
import AppStore from "assets/images/png/iso-store-logo.png";
import PlayStore from "assets/images/png/play-store-logo.png";
import Logo from "assets/images/svg/click-for-marry02.svg";
import { Link } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-wrapper">
      <div className="content-wrapper container">
        <div className="footer-container">
          <div className="left-container">
            <div className="content-section">
              <Link to="/" className="logo-container brand-logo">
                <img src={Logo} alt="MeFriend logo" />
              </Link>
              <p className="footer-description mt-2">
                Click4marry.com, a subsidiary of Madhyamam Daily under Ideal
                Publications Trust, is a trusted matchmaking platform designed
                for the Indian community, with a special focus on Keralites.
              </p>
              <div className="app-store-links mt-6">
                <a
                  href="https://apps.apple.com/in/app/click4marry/id1613457079"
                  className="store-logo-container"
                  target="_blank"
                >
                  <img src={AppStore} alt="MeFriend logo" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.madhyamam.click4marry&pcampaignid=web_share"
                  className="store-logo-container"
                  target="_blank"
                >
                  <img src={PlayStore} alt="MeFriend logo" />
                </a>
              </div>
            </div>
            <div className="footer-social-container main-view">
              <div className="social-icons">
                {[Facebook, Instagram, Youtube, SocialX].map((Icon, i) => (
                  <a key={i} href="#" target="_blank" rel="noopener noreferrer">
                    <Icon />
                  </a>
                ))}
              </div>
              <p className="copyright-text">
                © {currentYear} click4marry. All rights reserved.
              </p>
            </div>
          </div>

          <div className="footer-right-container view-change">
            <div className="new-section">
              <ul className="footer-links-container basic-blocks">
                <span className="footer-heading">Quick Links</span>
                {[
                  { name: "Explore", path: "/explore" },
                  { name: "Engage", path: "/engage" },
                  { name: "Connect", path: "/connect" },
                  { name: "Subscription plan", path: "/plans/list" },
                  { name: "Blog", path: "/blog" },
                  { name: "Success stories", path: "/success-stories" },
                  { name: "Wedding stores", path: "/wedding-store" },
                ].map((item, i) => (
                  <li key={i}>
                    <Link className="footer-links" to={item.path}>
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>

              <ul className="footer-links-container basic-blocks">
                <span className="footer-heading">Legal</span>
                <li>
                  <Link className="footer-links" to="/terms-and-conditions">
                    Terms of service
                  </Link>
                </li>
                <li>
                  <Link className="footer-links" to="/privacy-policy">
                    Privacy policy
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-links-secondary">
              {/* <div className="second-section view-change"> */}
              <ul className="footer-links-container basic-blocks">
                <span className="footer-heading">Address</span>
                <li>
                  <span className="footer-links address">
                    PB No. 1708, Silver Hills PO, Calicut -12
                  </span>
                </li>
              </ul>
              <ul className="footer-links-container basic-blocks">
                <span className="footer-heading">Contact</span>
                <li>
                  <a className="footer-links" href="tel:04952731500">
                    0495 2731500
                  </a>
                </li>
              </ul>
              {/* </div> */}
              <ul className="footer-links-container">
                <span className="footer-heading">Email</span>
                <li>
                  <a
                    className="footer-links"
                    href="mailto:help@click4marry.com"
                  >
                    help@click4marry.com
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-social-container duplicate-view">
              <div className="social-icons">
                {[Facebook, Instagram, Youtube, SocialX].map((Icon, i) => (
                  <a key={i} href="#" target="_blank" rel="noopener noreferrer">
                    <Icon />
                  </a>
                ))}
              </div>
              <p className="copyright-text">
                © {currentYear} click4marry. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
